/* istanbul ignore file */
export * from './ColorSelectFailedNotification';
